import * as React from 'react';

import BaseSettingsLayout from './BaseSettingsLayout';
import SettingsSupport from '../containers/settings/SettingsSupport';

export default function () {
  return BaseSettingsLayout(
    <SettingsSupport />
  );
};
